export const decodeGoogleAddressComponents = (addressComponents) => {
    if (!addressComponents) {
        return {
            address: "",
            city: "",
            postcode: "",
            country: "",
        };
    }
    const postcode = addressComponents.filter((i) => i.types.includes("postal_code"));
    const streetNumbers = addressComponents.filter((i) => i.types.includes("street_number"));
    const streetNumber = (streetNumbers?.length && streetNumbers[0].short_name) || "";
    const addresses = addressComponents.filter((i) => i.types.includes("route"));
    const address = (addresses?.length && addresses[0].short_name) || "";
    const city = addressComponents.filter((i) => i.types.includes("locality") ||
        i.types.includes("postal_town") ||
        i.types.includes("sublocality"));
    const country = addressComponents.filter((i) => i.types.includes("country"))[0]?.short_name || "";
    return {
        address: `${address} ${streetNumber}`.trim(),
        city: (city?.length && city[0].short_name) || "",
        postcode: (postcode?.length && postcode[0].short_name) || "",
        country: country || "",
    };
};
//# sourceMappingURL=google-helpers.js.map